import { connect, ConnectedProps } from "react-redux";
import * as jwt_decode from "jwt-decode";
import * as ImputationsStore from "../../../../redux/middleware/CashFlow-PaymentImputations.Middleware";
import * as DebtsStore from "../../../../redux/middleware/CashFlow-Debts.Middleware";
import * as PersonsStore from "../../../../redux/middleware/Persons.Middleware";

// models
import { AppState } from "../../../../redux/reducers";
import { Payment } from "../../../../models/Entities/CashFlow/Payment/Payment";
import { Debt } from "../../../../models/Entities/CashFlow/Debt/Debt";
import { nameOf } from "../../General/Cashflow.General.Functions";

export interface IProps {
    payment: Payment | null;
    isOpen: boolean;
    onClose: () => void;
    title?: string;
}

const mapStateToProps = (state: AppState, ownProps: IProps) => {
    const persons = state.Persons?.list || [];
    const tenantId: string = state?.oidc?.user?.access_token
        ? ((jwt_decode.jwtDecode(state.oidc.user.access_token) as { tenantId?: string })?.tenantId ?? '')
        : '';
    const payment = ownProps.payment;

    // Las deudas que este movimiento puede cancelar: las que el pagador le debe al cobrador.
    const centerCollects = !!payment && payment.receiver === tenantId;
    const stored: Debt[] = centerCollects ? (state.CashFlowDebts?.DebtsAsCreditor || []) : (state.CashFlowDebts?.DebtsAsDebtor || []);
    const candidates = payment
        ? stored.filter((debt) => debt.debtor === payment.payer && debt.creditor === payment.receiver)
        : [];

    return {
        OwnerId: tenantId,
        CenterCollects: centerCollects,
        CandidateDebts: candidates,
        isLoadingDebts: state.CashFlowDebts?.isLoadingAll ?? false,
        debtsLoaded: state.CashFlowDebts?.successLoadingAll === true || state.CashFlowDebts?.failOnLoadingAll === true,
        isCreatingImputation: state.CashFlowPaymentImputations?.isCreatingImputation ?? false,
        successCreatingImputation: state.CashFlowPaymentImputations?.successCreatingImputation,
        failOnCreatingImputation: state.CashFlowPaymentImputations?.failOnCreatingImputation ?? false,
        error: state.CashFlowPaymentImputations?.error,
        NameOf: (identifier: string | undefined) => nameOf(persons, tenantId, identifier || '')
    };
};

const mapDispatchToProps = {
    CreatePaymentImputation: ImputationsStore.actionCreators.CreatePaymentImputation,
    GetPaymentImputations: ImputationsStore.actionCreators.GetPaymentImputations,
    GetAllDebtsByCreditor: DebtsStore.actionCreators.GetAllDebtsByCreditor,
    GetAllDebtsByDebtor: DebtsStore.actionCreators.GetAllDebtsByDebtor,
    GetAllPersons: PersonsStore.actionCreators.GetAllPersons
};

export const connector = connect(mapStateToProps, mapDispatchToProps);
export type Props = IProps & ConnectedProps<typeof connector>;
